import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Home, BriefcaseBusiness, CalendarRange, Info, Cast, Folders, MessageCircleMore,
CalendarSearch, Group, Logs, Lightbulb, List
} from 'lucide-react'
import { Menu } from "antd";

const Side = ({ collapsed }) => {
  const navigate = useNavigate();
  const [iconSize, setIconSize] = useState(18);
  const [selectedKey, setSelectedKey] = useState("/");

  const commonStyle = {
    style: {
      display: 'flex',
      alignItems: 'center',
    }
  }

  const getTextStyle = (isSelected) => {
    return `text-xs tracking-wide [text-shadow:_3px_3px_3px_rgba(0,0,0,0.5)] ${
      isSelected 
        ? "text-white font-medium" 
        : "text-gray-200 hover:text-white transition-colors duration-200"
    }`;
  };

  const menuItems = [
    {
      key: "/",
      icon: <Home size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/")}>
          Home
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/portfolios",
      icon: <List size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/portfolios")}>
          Portfolios
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/calendar",
      icon: <CalendarSearch size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/calendar")}>
          Calendar
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/resources",
      icon: <Info size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/resources")}>
          Resources
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/pages",
      icon: <Group size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/pages")}>
          Pages
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/files",
      icon: <Folders size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/files")}>
          Files
        </span>
      ) : null,
      ...commonStyle
    },
    {
      key: "/inference/chat",
      icon: <MessageCircleMore size={iconSize} strokeWidth={2} color={'#eeefff'} />,
      label: !collapsed ? (
        <span className={getTextStyle(selectedKey === "/inference/chat")}>
          Chat
        </span>
      ) : null,
      ...commonStyle
    },
  ];

  const handleMenuClick = (e) => {
    navigate(e.key);
    setSelectedKey(e.key);
  };

  return (
    <Menu
      mode="vertical"
      selectedKeys={[selectedKey]}
      onClick={handleMenuClick}
      theme="light"
      className="hide-scrollbar bg-transparent"
      items={menuItems}
      style={{
        background: "transparent",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    />
  );
};

export default Side;